'use client';

import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import dynamic from 'next/dynamic';
import { FC, RefObject, useState } from 'react';
import { Icon } from '@/components/ui/icon/icon';
import useDeferUntilIdle from '@/hooks/use-defer-until-idle';
import { useTranslation } from '@/providers/app-provider/app-provider';

const SearchAutocomplete = dynamic(
  () => import('@/components/common/layout/secondary-app-bar/search-input/search-autocomplete'),
  { ssr: false },
);

type DeferredSearchInputProps = {
  ref?: RefObject<HTMLInputElement | null>;
  isVisible?: boolean;
  setIsSearchOpen?: (isOpen: boolean) => void;
  onNavigate?: () => void;
};

const DeferredSearchInput: FC<DeferredSearchInputProps> = props => {
  const { t } = useTranslation();
  const isIdleReady = useDeferUntilIdle({ timeout: 3000 });
  const [isActivated, setIsActivated] = useState(false);

  if (isActivated || isIdleReady || props.isVisible) {
    return <SearchAutocomplete {...props} onActivate={() => setIsActivated(true)} />;
  }

  return (
    <div className="relative w-full">
      <Icon
        icon={faMagnifyingGlass}
        className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-gray-400"
      />
      <input
        type="search"
        aria-label={t?.common.layout.search ?? 'Search'}
        placeholder={t?.common.layout.search}
        className="border-default-200 w-full min-w-0 rounded-full border bg-white py-2 pr-3 pl-10"
        onFocus={() => setIsActivated(true)}
        readOnly
      />
    </div>
  );
};

export default DeferredSearchInput;
